import _extends from "@babel/runtime/helpers/esm/extends";
import React, { memo } from 'react';
import { number, oneOf } from 'prop-types';
import { StripMultiColors } from './strip.styles';

const Strip = props => /*#__PURE__*/React.createElement(StripMultiColors, _extends({
  "data-testid": "strip"
}, props));

Strip.defaultProps = {
  position: 'absolute',
  size: 5
};
process.env.NODE_ENV !== "production" ? Strip.propTypes = {
  size: number,
  position: oneOf(['absolute', 'static', 'relative'])
} : void 0;
export default /*#__PURE__*/memo(Strip);